import React, { FC, MouseEvent, ReactNode } from "react";

export enum ButtonType {
  PRIMARY,
  SECONDARY,
  LINK,
  DANGEROUS,
  STOP,
}

export interface ButtonProps {
  type: ButtonType;
  className?: string;
  children?: ReactNode;
  disabled?: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  id?: string;
}

const specificTypeClassNameMap: Record<ButtonType, string> = {
  [ButtonType.PRIMARY]:
    "flex items-center justify-center rounded-lg border border-themed-accent bg-themed-accent px-3.5 py-1.5 text-white hover:border-themed-accentHover hover:bg-themed-accentHover focus:border-themed-accentHover focus:bg-themed-accentHover disabled:!bg-themed-elevated",
  [ButtonType.SECONDARY]:
    "flex items-center justify-center rounded-lg border border-themed-border bg-themed-card px-3.5 py-1.5 text-themed-text hover:border-themed-borderSecondary hover:bg-themed-elevated focus:border-themed-accent",
  [ButtonType.LINK]:
    "text-themed-accentForeground hover:text-themed-accentForegroundHover focus:text-themed-accentForegroundHover",
  [ButtonType.DANGEROUS]:
    "flex items-center justify-center rounded-lg border border-[var(--danger-border)] bg-themed-card px-3.5 py-1.5 text-[var(--danger)] hover:bg-[var(--danger-soft)] focus:border-[var(--danger)] disabled:!bg-themed-elevated",
  [ButtonType.STOP]:
    "flex items-center justify-center rounded-lg border border-themed-accent bg-themed-accent px-3.5 py-1.5 text-white hover:border-[var(--danger)] hover:bg-[var(--danger)] focus:border-[var(--danger)] focus:bg-[var(--danger)] disabled:!bg-themed-elevated",
};

const Button: FC<ButtonProps> = ({ type, className, children, ...props }) => {
  return (
    <button
      className={`select-none font-manrope text-[13px] font-semibold leading-[20px] transition-colors disabled:pointer-events-none disabled:!border-themed-border disabled:!text-themed-textSecondary ${
        specificTypeClassNameMap[type]
      } ${className ? className : ""}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
